import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  loggedUserCountrySelector,
  targetUserCountrySelector,
} from '../../../redux/context/selectors';
import { selectCountryList } from '../../../redux/data/selectors';

export function useLoggedUserCountry() {
  const loggedUserCountryName = useSelector(loggedUserCountrySelector);
  const targetUserCountryName = useSelector(targetUserCountrySelector);

  const safeUserCountryName = targetUserCountryName || loggedUserCountryName;

  const targetCountry = useSelector(selectCountryList).find(
    ({ name }) => name === safeUserCountryName,
  );

  if (!targetCountry) return null;

  const targetCountryEntity = {
    label: targetCountry.name,
    value: targetCountry.isoCode,
  };

  return useMemo(() => targetCountryEntity, [
    safeUserCountryName,
    targetCountry,
  ]);
}



// WEBPACK FOOTER //
// ./src/components/DependentForm/utils/useLoggedUserCountry.js